const isClosingTime = new Date().getHours() >= 16;

export default isClosingTime;
